import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=17da8603&scoped=true"
import script from "./index.page.vue?vue&type=script&lang=ts"
export * from "./index.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17da8603",
  null
  
)

export default component.exports